import React from 'react';
import Anime from 'react-anime';
import './Photo.scss';
export default ({ photo, message, isActive }) => {
  const showMessage = {
    opacity: [
      { value: 0, duration: 0, },
      { value: 1, duration: 1000, delay: 1000, easing: 'linear' }
    ]
  }

  const bgImage = {
    backgroundImage: [
      { value: `url(${photo})`, duration: 0}
    ],
    opacity: [
      { value: 0, duration: 0, },
      { value: 1, duration: 1000, easing: 'linear' }
    ]
  }

  const dropBall = {
    translateY: [
      { value: '-50vh', duration: 0},
      { value: '100vh', duration: 2000, easing: 'linear' }
    ]
  }
  return (
    <div className="photo-slide-container">
      {isActive && (
        <Anime {...bgImage} className="photo">
          <div className="message-container">
            
          {isActive && (
            <Anime {...showMessage}>
              <h2 className="secondary-large message centered white-text">{message}</h2>
            </Anime>
          )}
          </div>
        </Anime>
      )}
      {isActive && (
      <Anime {...dropBall} className="ball">
        <div className="ball-1"></div>
      </Anime>
      )}
    </div>
  );
};